import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import { FLOOR_CONFIG } from './config';

export const createPhysicsWorld = (scene) => {
    const world = new CANNON.World({
        gravity: new CANNON.Vec3(0, -9.82, 0),
    });

    // Infinite plane fallback
    const groundMaterial = new CANNON.Material('ground');
    const groundShape = new CANNON.Plane();
    const groundBody = new CANNON.Body({ mass: 0, material: groundMaterial });
    groundBody.addShape(groundShape);
    groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);
    groundBody.position.y = -1;
    world.addBody(groundBody);

    // Visible shadow-receiving floor mesh
    const floorGeo = new THREE.PlaneGeometry(FLOOR_CONFIG.sizeX, FLOOR_CONFIG.sizeZ);
    const floorMat = new THREE.ShadowMaterial({ opacity: 0.4, depthWrite: false });
    const floorDebugMesh = new THREE.Mesh(floorGeo, floorMat);
    floorDebugMesh.receiveShadow = true;
    floorDebugMesh.rotation.x = -Math.PI / 2;
    floorDebugMesh.position.set(FLOOR_CONFIG.centerX, FLOOR_CONFIG.y, FLOOR_CONFIG.centerZ);
    floorDebugMesh.visible = true;
    floorDebugMesh.renderOrder = -2;
    scene.add(floorDebugMesh);
    window.myFloor = floorDebugMesh;

    // Finite box collider aligned with the visual floor
    const floorPhysicsBody = new CANNON.Body({ mass: 0 });
    floorPhysicsBody.addShape(
        new CANNON.Box(new CANNON.Vec3(FLOOR_CONFIG.sizeX / 2, 0.05, FLOOR_CONFIG.sizeZ / 2))
    );
    floorPhysicsBody.position.set(FLOOR_CONFIG.centerX, FLOOR_CONFIG.y - 0.05, FLOOR_CONFIG.centerZ);
    world.addBody(floorPhysicsBody);

    return { world, floorPhysicsBody, floorDebugMesh, floorGeo, floorMat };
};

export const createCharacterPhysicsBody = (world, spawnPos) => {
    const radius = 0.2;
    const height = 0.8;
    const shape  = new CANNON.Cylinder(radius, radius, height, 12);
    const body   = new CANNON.Body({
        mass: 5,
        type: CANNON.Body.DYNAMIC,
        fixedRotation: true,
    });
    const shapeQuat = new CANNON.Quaternion();
    shapeQuat.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2);
    body.addShape(shape, new CANNON.Vec3(0, height / 2, 0), shapeQuat);
    body.position.set(spawnPos.x, spawnPos.y, spawnPos.z);
    world.addBody(body);
    return body;
};
